import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

import ScreenHeading from "../../Utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../Utilities/ScrollService";
import Animations from "../../Utilities/Animations";
import "./Accolades.css";

import Accolade1 from "../../../src/img/Accolades/redeemed-christian-church.jpg";
import Accolade2 from "../../../src/img/Accolades/twins-pharmacy.jpg";
import Accolade3 from "../../../src/img/Accolades/united-states-patent.jpg";
import Accolade4 from "../../../src/img/Accolades/landmark-technologies.jpg"
import shape from "../../../src/img/Accolades/shape-bg.png";
//Import other images similarly

export default function Accolades(props) {
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;
    Animations.animations.fadeInScreen(props.id);
  };

  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  const options = {
    loop: true,
    margin: 0,
    nav: true,
    animateIn: "bounceInRight",
    animateOut: "bounceOutRight",
    dots: true,
    autoplay: true,
    smartSpeed: 1000,
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 1,
      },
      1000: {
        items: 3,
      },
    },
  };

  return (
    <div>
      <ScreenHeading
        title={"Accolades"}
        subHeading={"Some Awards and Recognitions I have gotten."}
      />
      <section className="accolades-section fade-in" id={props.id || ""}>
        <div className="container">
          <div className="row">
            <OwlCarousel
              className="owl-carousel"
              id="accolades-carousel"
              {...options}
            >
              <div className="col-lg-12">
                <div className="accolades-item">
                  <div className="accolade-picture">
                    <div><img src={Accolade1} alt="Not responding" /></div>
                  </div>
                  <div className="accolade-info">
                    <h5>Virtuous Woman Award</h5>
                    <p>The Redeemed Christian Church of God, Canada (Dominion Cathedral).</p>
                  </div>
                </div>
              </div>

              <div className="col-lg-12">
                <div className="accolades-item">
                  <div className="accolade-picture">
                    <img src={Accolade2} alt="Not responding" />
                  </div>
                  <div className="accolade-info">
                    <h5>Appreciation Award</h5>
                    <p>Twins Pharmacy, Canada.</p>
                  </div>
                </div>
              </div>

              <div className="col-lg-12">
                <div className="accolades-item">
                  <div className="accolade-picture">
                    <img src={Accolade3} alt="Not responding" />
                  </div>
                  <div className="accolade-info">
                    <h5>United States Inventor Patent</h5>
                    <p>United States Patent and Trademark Office.</p>
                  </div>
                </div>
              </div>

              <div className="col-lg-12">
                <div className="accolades-item">
                  <div className="accolade-picture">
                    <img src={Accolade4} alt="Not responding" />
                  </div>
                  <div className="accolade-info">
                    <h5>Graduate Proffesional Diploma</h5>
                    <p>(DevOps and Cloud Engineering)<br/> Landmark Technologies, Canada.</p>
                  </div>
                </div>
              </div>
            </OwlCarousel>
          </div>
        </div>
      </section>

      <div className="footer-image">
        <img src={shape} alt="Not responding" />
      </div>

    </div>
  );
}